export { default as SendReceipt } from './send-receipt';
